import { upButton } from '../../assets/svg/upButton';
import { useOnScroll } from '../../hooks/useOnScroll';

import styles from './ButtonUp.module.scss';


export const ButtonUp = () => {

    const { isShow, handleScrollUp } = useOnScroll();

    return (
        <>
            {isShow &&
                <button
                    className={styles.upButton}
                    onClick={handleScrollUp}
                    type='button'
                >
                    {upButton()}
                    <span className='visually-hidden'>Скролл вверх</span>
                </button>
            }
        </>
    );
};